export default "__VITE_ASSET__BJKgrR$r__"